// extracted by mini-css-extract-plugin
export default {"textoGanador":"textoPerdedor_textoGanador__85ae4","br":"textoPerdedor_br__c75Hm"};